import React from "react";
import { AssetSvg } from "../../../assets";
type Props = {
	onToggle: () => void,
	sharing: boolean,
	screenShareStatus: boolean,
}
export function ToggleScreenShareButton(props: Props) {
	const { onToggle, sharing, screenShareStatus } = props;
	return (
		<>
			{!sharing ?
				<button
					type="button"
					className="btn btn-opaque conference-control-btn"
					title={screenShareStatus? "Screen share running" : "Share your screen"}
					onClick={!screenShareStatus ? onToggle : () => { console.log("Nothing happend") }}
					disabled={screenShareStatus}
				>
					{!screenShareStatus ? <AssetSvg.ScreenShareOn /> :		
						<AssetSvg.ScreenShareRunning />}
				</button>
				:

			<button
				type="button"
				className="btn btn-opaque conference-control-btn"
				title="Stop share"
				onClick={onToggle}
				style={{"background":"red"}}
			>
			<AssetSvg.ScreenShareEnd />
			</button>
}

		</>
	);
}
